var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenubarUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "white",
    strokeWidth: 1.5,
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.75C9.92893 3.75 8.25 5.42893 8.25 7.5C8.25 9.57107 9.92893 11.25 12 11.25C14.0711 11.25 15.75 9.57107 15.75 7.5C15.75 5.42893 14.0711 3.75 12 3.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13C5.92893 13 4.25 14.6789 4.25 16.75V17.9383C4.25 18.6915 4.79588 19.3337 5.53927 19.4551C9.8181 20.1537 14.1819 20.1537 18.4607 19.4551C19.2041 19.3337 19.75 18.6915 19.75 17.9383V16.75C19.75 14.6789 18.0711 13 16 13H15.6591C15.4746 13 15.2913 13.0292 15.1159 13.0864L14.2504 13.3691C12.7881 13.8465 11.2119 13.8465 9.74959 13.3691L8.88407 13.0864C8.70869 13.0292 8.52536 13 8.34087 13H8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenubarUser);
export default __webpack_public_path__ + "static/media/Menubar_user.da838f9034fa2a5074f8941398a98f54.svg";
export { ForwardRef as ReactComponent };